import { render, staticRenderFns } from "./DynamicPartsList.vue?vue&type=template&id=4460f96e&scoped=true&"
import script from "./DynamicPartsList.vue?vue&type=script&lang=js&"
export * from "./DynamicPartsList.vue?vue&type=script&lang=js&"
import style0 from "./DynamicPartsList.vue?vue&type=style&index=0&id=4460f96e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4460f96e",
  null
  
)

export default component.exports